export const leftNavigation = (() => {
  const setLeftNavigation = () => {
    const toggleButtons = document.getElementsByClassName('js-toggle')
    for (var i = 0; i < toggleButtons.length; i++) {
      toggleButtons[i].addEventListener('click', toggleChild)
    }
  }

  const toggleChild = (event: Event) => {
    event.preventDefault()
    const targetElement = event.currentTarget as HTMLElement //The clicked element
    targetElement.ariaExpanded = targetElement.ariaExpanded = targetElement.ariaExpanded === 'true' ? 'false' : 'true'
    toggleClasses(targetElement.closest('.has-subnav') as HTMLElement)
    const ulElement = targetElement.closest('ul')
    if (ulElement) {
      !ulElement.classList.contains('hasopen')
        ? ulElement.classList.add('hasopen')
        : ulElement.classList.remove('hasopen')
    }
  }

  const toggleClasses = (element: HTMLElement) => {
    const isOpen = element.classList.contains('open')
    const subnav = element.querySelector(':scope > .subnav') as HTMLElement | null

    if (isOpen) {
      element.classList.remove('open')
      if (subnav) {
        subnav.style.visibility = 'hidden'
      }
    } else {
      element.classList.add('open')
      if (subnav) {
        subnav.style.visibility = 'visible'
      }
    }
  }
  setLeftNavigation()
})()
